import { render, staticRenderFns } from "./tabComponent.vue?vue&type=template&id=1bd35d72&scoped=true&"
import script from "./tabComponent.vue?vue&type=script&lang=js&"
export * from "./tabComponent.vue?vue&type=script&lang=js&"
import style0 from "./tabComponent.vue?vue&type=style&index=0&id=1bd35d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd35d72",
  null
  
)

export default component.exports